import React, { Component, PropTypes } from 'react';
import { connect } from 'react-redux';
import { Dialog, Chip, Avatar, Checkbox } from 'material-ui';
import MessageBox from '../generic-components/message-box';
import {
  closeBulkResendDialog as closeBulkResendDialogAction,
  bulkResend as bulkResendAction,
  updateBulkResendDialogProps,
} from '../../../stores/contracting/contract-list/contract-list-actions';
import FlatButton from '../../tc-ui/flat-button-with-loader';
import R from 'ramda';
import pluralize from 'pluralize';
const isNilOrEmpty = R.either(R.isNil, R.isEmpty);
const propTypes = {
  open: PropTypes.bool,
  partners: PropTypes.array,
  onRequestClose: PropTypes.func,
  sending: PropTypes.bool,
  bulkResend: PropTypes.func,
  customizedMessage: PropTypes.string,
  companyType: PropTypes.string,
  updateProps: PropTypes.func,
  BCCToSelf: PropTypes.bool,
  changeEmail: PropTypes.bool,
  sent: PropTypes.bool,
  showAllPartners: PropTypes.bool,
  subject: PropTypes.string,
};

class BulkResendDialog extends Component {
  shouldComponentUpdate(nextProps) {
    const propKeys = R.keys(propTypes).filter(key => propTypes[key] !== PropTypes.func);
    return !R.equals(R.pick(propKeys, this.props), R.pick(propKeys, nextProps));
  }
  render() {
    const { partners, onRequestClose, sending, bulkResend, customizedMessage, updateProps, changeEmail, sent, showAllPartners, subject } = this.props;
    const isSupplier = this.props.companyType === 'Supplier';
    if (isNilOrEmpty(partners)) return <div/>;
    return (
      <Dialog
        open={this.props.open}
        autoScrollBodyContent
        title={`Resend ${isSupplier ? 'Contracts' : 'Requests'}`}
        titleStyle={{ backgroundColor: '#00BCD4', color: '#ffffff', fontSize: '18px', padding: '2%' }}
        actions={[
          <FlatButton primary label={sent ? 'Close' : 'Cancel'} loader={sending} onTouchTap={onRequestClose}/>,
          <FlatButton disabled={sent} secondary label="Resend" loader={sending} onTouchTap={bulkResend} />,
        ]}
      >
        {
          sent ? <div style={{ marginTop: '20px' }}>
            Congratulations, we've resent your {isSupplier ? 'contracts' : 'requests'}!
          </div> : (
            <div style={{ paddingTop: '8px' }}>
              <div style={{ display: 'flex', justifyContent: 'space-between' }}>
                <div style={{ width: '80%' }}>
                  {partners.slice(0, showAllPartners || partners.length < 6 ? partners.length : 5).map((partner, i) => {
                    const noOfContracts = R.pathOr(1, ['contractIds', 'length'], partner);
                    if (changeEmail && !partner.companyId) {
                      return (<input
                        key={i}
                        style={{ width: '350px', marginBottom: '8px' }}
                        value={partner.newEmail}
                        onChange={({ target: { value } }) => updateProps({
                          partners: R.update(i, R.merge(partner, { newEmail: value }), partners),
                        })}
                      />);
                    }
                    return (
                      <Chip key={i} style={{ marginBottom: '8px' }}>
                        {partner.avatar ? <Avatar src={partner.avatar} /> :
                          <Avatar>{R.head(partner.name || '')}</Avatar>}
                        {partner.name}&nbsp;({noOfContracts} {pluralize(isSupplier ? 'contract' : 'request', noOfContracts)})
                      </Chip>
                    );
                  })}
                  {partners.length >= 6 ? <a style={{ cursor: 'pointer', display: 'block' }} onClick={() => updateProps({ showAllPartners: !showAllPartners })}>{
                    showAllPartners ? 'Show Less' : `Show All ${partners.length} Partners`
                  }</a> : <a/>}
                </div>
                {
                  /*
                   <FlatButton
                   backgroundColor="rgba(0, 0, 0, 0.1)"
                   label={changeEmail ? 'cancel' : 'change email'}
                   disabled={partners.every(R.prop('companyId'))}
                   secondary={!changeEmail}
                   primary={changeEmail}
                   onTouchTap={() => updateProps({
                   changeEmail: !changeEmail,
                   partners: partners.map(obj => obj.companyId ? obj : R.merge(obj, { newEmail: changeEmail ? '' : obj.email })),
                   })}
                   />
                   */
                }
              </div>
              <div>
                <label>Subject:</label>
                <br/>
                <input
                  value={subject || ''}
                  style={{ width: '100%' }}
                  onChange={e => updateProps({ subject: e.target.value })}
                />
              </div>
              <label>Message:</label>
              <MessageBox
                value={customizedMessage}
                onChange={(value) => updateProps({ customizedMessage: value })}
                placeholder="You can enter a message here."
              />
            </div>
          )
        }
      </Dialog>
    );
  }
};

BulkResendDialog.propTypes = propTypes;
const mapStateToProps = ({ contracting, user }) => ({
  companyType: user.getIn(['user', 'type']),
  ...contracting.contractList.get('bulkResendDialog').toJS(),
});
const mapActionToProps = dispatch => ({
  onRequestClose: () => dispatch(closeBulkResendDialogAction()),
  bulkResend: (...args) => dispatch(bulkResendAction(...args)),
  updateProps: (...args) => dispatch(updateBulkResendDialogProps(...args)),
});
export default connect(mapStateToProps, mapActionToProps)(BulkResendDialog);



// WEBPACK FOOTER //
// ./src/app/components/contracting/contract-list/bulk-resend-dialog.jsx